import { useEffect } from "react";

export default function App() {
  useEffect(() => {
    // Redirect to the API endpoint
    window.location.replace("https://api.unlock.fit/app/redirect");

    // Attempt to close the tab after a short delay
    setTimeout(() => {
      window.close();
    }, 1000);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
}
